module.exports = __webpack_public_path__ + "static/media/Cyber-purplish-blue.4f4ed1b1.svg";